module.exports = __webpack_public_path__ + "img/video-img.a1d1ac63.png";